import script from "./ModelCardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelCardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ModelCardSkeleton.vue?vue&type=style&index=0&id=ef3bd4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef3bd4f4"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
